import { useState } from "react";
import { SupportModal } from "./SupportModal";
import { FeedbackModal } from "./FeedbackModal";

export function HelpModalOptions({ innerRef, openHelpOptions }: HelpModalOptionsProps) {
  const [supportHover, setSupportHover] = useState(false);
  const [feedbackHover, setFeedbackHover] = useState(false);
  const [supportModalState, setSupportModalState] = useState(false);
  const [feedbackModalState, setFeedbackModalState] = useState(false);

  const helpModalOptionsStyles = {
    width: "200px",
    bottom: "90px",
    right: "90px",
    boxShadow: "0px 2px 28px rgba(0, 0, 0, 0.2)",
    transform: `scale(${openHelpOptions ? "1" : "0"})`,
    transformOrigin: "100% 100%",
    transition: "all 0.2s ease",
  };

  return (
    <>
      <div ref={innerRef} className="br4 bg-white flex flex-column z-1 fixed" style={helpModalOptionsStyles}>
        <div className="mv2 mh2">
          <div className={`pv3 ph3 pointer br4 ${supportHover ? "bg-near-white" : ""}`} onClick={() => setSupportModalState(!supportModalState)} onMouseOver={() => setSupportHover(true)} onMouseOut={() => setSupportHover(false)}>
            <div className="fw5">Request Support</div>
            <div className="fw4 gray f6">Require assistance?</div>
          </div>
          <div className={`pv3 ph3 pointer br4 ${feedbackHover ? "bg-near-white" : ""}`} onClick={() => setFeedbackModalState(!feedbackModalState)} onMouseOver={() => setFeedbackHover(true)} onMouseOut={() => setFeedbackHover(false)}>
            <div className="fw5">Share Feedback</div>
            <div className="fw4 gray f6">How can we improve your experience?</div>
          </div>
        </div>
      </div>
      <SupportModal modalState={supportModalState} setModalState={setSupportModalState} />
      <FeedbackModal modalState={feedbackModalState} setModalState={setFeedbackModalState} />
    </>
  );
}
